import React from 'react';
import Highcharts from 'highcharts';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import UpdateParentWindow from "./update-parent-window/Updater.js";
import Home from './views/Home.js';
import Funding from './views/Funding.js';
import Comparison from './views/Comparison';
import Contact from './views/Contact';
import Iframepoc from './views/Iframepoc.js';
import TeaserBox from './views/TeaserBox.js';
import ButtonArea from './ButtonArea';
import SidePanelContent from "./side-panel/SidePanel.js";
import Navigation from "./navigation/Navigation.js";
import ImageZoom from "./ImageZoom.js";
import { config } from "./config";

class App extends React.Component {

  constructor(props) {
    super(props);
    this.resizeFns = {};
    this.fetchesDone = 0;
    this.changeRoute = false;
    let hash = window.location.hash,
    defaultValues = {
      phase: 1,
      implementationModel: null,
      selectedFundings: [],
      investmentSize: 10,
      payBackTime: 20,
      completionYear: new Date().getFullYear(),
      varsLoanInterest: 0.5,
      varsGreenLoanInterest: 1.97,
      varsShortRentInitialRent: 10,
      varsShortRentIndexing: 2,
      varsShortRentRedemptionValue: 0,
      varsLongRentInitialRent: 6.5,
      varsLongRentIndexing: 2,
      varsLongRentRedemptionValue: 0,
      varsLeasingInterest: 0.6,
      varsLeasingResidualValue: 33.33,
      varsLeasingContractTime: 20,
      varsGreenLeasingInterest: 2.12,
      varsGreenLeasingResidualValue: 25,
      varsGreenLeasingContractTime: 20,
    };
    if(hash.length) {
      defaultValues = {
        phase: this._parsePhase(hash.split('|')[0]) || defaultValues.phase,
        implementationModel: hash.split('|')[1] || defaultValues.implementationModel,
        selectedFundings: hash.split('|')[2] && hash.split('|')[2].length ? this._parseArray(hash.split('|')[2]) : defaultValues.selectedFundings,
        investmentSize: this._parseNumber(hash.split('|')[3]) || defaultValues.investmentSize,
        payBackTime: this._parseNumber(hash.split('|')[4]) || defaultValues.payBackTime,
        completionYear: this._parseNumber(hash.split('|')[5]) || defaultValues.completionYear,
        varsLoanInterest: this._parseNumber(hash.split('|')[6]) || defaultValues.varsLoanInterest,
        varsGreenLoanInterest: this._parseNumber(hash.split('|')[7]) || defaultValues.varsGreenLoanInterest,
        varsShortRentInitialRent: this._parseNumber(hash.split('|')[8]) || defaultValues.varsShortRentInitialRent,
        varsShortRentIndexing: this._parseNumber(hash.split('|')[9]) || defaultValues.varsShortRentIndexing,
        varsShortRentRedemptionValue: this._parseNumber(hash.split('|')[10]) || defaultValues.varsShortRentRedemptionValue,
        varsLongRentInitialRent: this._parseNumber(hash.split('|')[11]) || defaultValues.varsLongRentInitialRent,
        varsLongRentIndexing: this._parseNumber(hash.split('|')[12]) || defaultValues.varsLongRentIndexing,
        varsLongRentRedemptionValue: this._parseNumber(hash.split('|')[13]) || defaultValues.varsLongRentRedemptionValue,
        varsLeasingInterest: this._parseNumber(hash.split('|')[14]) || defaultValues.varsLeasingInterest,
        varsLeasingResidualValue: this._parseNumber(hash.split('|')[15]) || defaultValues.varsLeasingResidualValue,
        varsLeasingContractTime: this._parseNumber(hash.split('|')[16]) || defaultValues.varsLeasingContractTime,
        varsGreenLeasingInterest: this._parseNumber(hash.split('|')[17]) || defaultValues.varsGreenLeasingInterest,
        varsGreenLeasingResidualValue: this._parseNumber(hash.split('|')[18]) || defaultValues.varsGreenLeasingResidualValue,
        varsGreenLeasingContractTime: this._parseNumber(hash.split('|')[19]) || defaultValues.varsGreenLeasingContractTime,

      };
    }
    this.state = {
      loading: true,
      phase: defaultValues.phase, // 1-4
      implementationModel: defaultValues.implementationModel, // 1-5 or null (null = not selected)
      selectedFundings: defaultValues.selectedFundings, // Array of numbers?
      investmentSize: defaultValues.investmentSize, // shown in millions
      payBackTime: defaultValues.payBackTime, // shown in years
      completionYear: defaultValues.completionYear, // shown as a year
      varsLoanInterest: defaultValues.varsLoanInterest,
      varsGreenLoanInterest: defaultValues.varsGreenLoanInterest,
      varsShortRentInitialRent: defaultValues.varsShortRentInitialRent,
      varsShortRentIndexing: defaultValues.varsShortRentIndexing,
      varsShortRentRedemptionValue: defaultValues.varsShortRentRedemptionValue,
      varsLongRentInitialRent: defaultValues.varsLongRentInitialRent,
      varsLongRentIndexing: defaultValues.varsLongRentIndexing,
      varsLongRentRedemptionValue: defaultValues.varsLongRentRedemptionValue,
      varsLeasingInterest: defaultValues.varsLeasingInterest,
      varsLeasingResidualValue: defaultValues.varsLeasingResidualValue,
      varsLeasingContractTime: defaultValues.varsLeasingContractTime,
      varsGreenLeasingInterest: defaultValues.varsGreenLeasingInterest,
      varsGreenLeasingResidualValue: defaultValues.varsGreenLeasingResidualValue,
      varsGreenLeasingContractTime: defaultValues.varsGreenLeasingContractTime,
      phases: [
        {
          id: 1,
          path: '/',
          name: 'Toteutustapa'
        },
        {
          id: 2,
          path: '/phase2',
          name: 'Rahoitusmalli'
        },
        {
          id: 3,
          path: '/phase3',
          name: 'Vertailu'
        },
        {
          id: 4,
          path: '/phase4',
          name: 'Yhteydenotto'
        },
      ],
      sidePanelSections: {
        basicinfo: {
          open: true,
          title: "Perustiedot",
        },
        projectinfo: {
          open: true,
          title: "Hanketiedot",
        },
        variables: {
          open: false,
          title: "Korko ja muut muuttujat"
        }
      },
      noUserSelections: false,
      implementationModels: [],
      fundingModels: [],
      availableFundingModels: [],
    };
    this.updateState = this.updateState.bind(this);
    window.addEventListener('resize', this.resize);
  }

  componentDidMount() {
    Highcharts.setOptions({
      lang: {
        numericSymbols: ["t", "M", "mrd", "T", "P", "E"]
      },
    });
    this.fetchImpModels();
    this.fetchFundModels();
  }

  apiUrl() {
    return config.WORDPRESS_API;
  }

  fetchImpModels() {
    let url = this.apiUrl() + '/wp-json/wp/v2/investment_model';
    fetch(url, {
      method: 'GET',
      headers: new Headers({
        'Accept': 'application/json'
      }),
    })
    .then((resp) => resp.json())
    .then((data) => {
      return data.map((obj) => {
        return {
          id: obj.id,
          slug:obj.slug,
          title: obj.title.rendered,
          description: obj.acf.description,
          use_cases: obj.acf.use_cases,
          benefits_and_risks: obj.acf.benefits_and_risks,
          taxonomies: [
            {
              term_id: obj.id,
              name: obj.title.rendered,
              slug: obj.slug,
            }
          ],
          order: obj.acf.order
        }
      })
    })
    .then((response) => {
      this.setState({
        implementationModels: response.sort((a, b) => a.order - b.order)
      }, () => {
        this.fetchDone();
      });
    }).catch((error) => {
      console.log("error for fetchImpModels",error);
    });
  }

  fetchFundModels() {
    let url = this.apiUrl() + '/wp-json/wp/v2/funding_models';
    fetch(url, {
      method: 'GET',
      headers: new Headers({
        'Accept': 'application/json'
      }),
    })
    .then((resp) => resp.json())
    .then((data) => {
      return data.map((obj) => {
        return {
          id: obj.id,
          slug: obj.slug,
          title: obj.title.rendered,
          description: obj.acf.description,
          benefits: obj.acf.benefits.map(text => text.text),
          disadvantages: obj.acf.disadvantages.map(text => text.text),
          investment_models: obj.acf.investment_models.map(model => model.post_name),
          link: obj.link,
          taxonomies: [
            {
              term_id: obj.id,
              name: obj.title.rendered,
              slug: obj.slug,
            }
          ],
          order: obj.acf.order
        }
      })
    })
    .then((response) => {
      this.setState({
        fundingModels: response,
        availableFundingModels: this.getAvailableFundingModels(this.state.implementationModel, response)
      }, () => {
        this.fetchDone();
      });
    }).catch((error) => {
      console.log("error for fetchFundModels",error);
    });
  }

  fetchDone() {
    this.fetchesDone++;
    if(this.fetchesDone === 2) {
      this.setState({loading: false}, () => {
        UpdateParentWindow(this.state, this.updateState);
      });
    }
  }

  updateState(object) {
    if(object.phase && object.phase !== this.state.phase) {
      this.changeRoute = true;
    }
    if ('payBackTime' in object) {
      let leasingContract = this.state.varsLeasingContractTime + object.payBackTime - this.state.payBackTime;
      let greenLeasingContract = this.state.varsGreenLeasingContractTime + object.payBackTime - this.state.payBackTime;
      this.setState(
        {varsLeasingContractTime: leasingContract > 0 ? leasingContract : 1,
         varsGreenLeasingContractTime: greenLeasingContract > 0 ? greenLeasingContract : 1},
        () => { UpdateParentWindow(this.state, this.updateState) });
    }
    this.setState(object, () => { if(!('parentWindow' in object)) { UpdateParentWindow(this.state, this.updateState) }});
    if ('implementationModel' in object) {
      this.setState(
        {selectedFundings: [],
         availableFundingModels: this.getAvailableFundingModels(object.implementationModel, this.state.fundingModels)},
        () => { UpdateParentWindow(this.state, this.updateState) });
    }
  };

  getAvailableFundingModels(implementationModel, allFundingModels) {
    return implementationModel === null ?
              allFundingModels :
              allFundingModels.filter(model => model.investment_models.includes(implementationModel))
                              .sort((a, b) => a.order - b.order);
  }

  resize = () => {
    let fns = Object.keys(this.resizeFns);
    fns.forEach((fn) => {
      this.resizeFns[fn]();
    });
  }

  _parseNumber(value) {
    let val = parseFloat(value);
    if(isNaN(val)) {
      return false;
    }
    return val;
  }

  _parseArray(array) {
    let parsedA = [];
    array = array.split(',');
    array.forEach((item) => {
      if(item.length) {
        parsedA.push(item);
      }
    });
    return parsedA;
  }

  _parsePhase(phase) {
    let parsedPhase = phase.split('phase')[1];
    return this._parseNumber(parsedPhase);
  }

  reRouteToHome(history) {
    setTimeout(() => {
      history.push("/");
    },0);
  }

  routeChange() {
    let newPath = window.location.hash === "#teaserbox" ? "/teaserbox" : this.state.phases[this.state.phase - 1].path;
    this.changeRoute = false;
    return <Redirect to={newPath} />;
  }

  render() {
    if(window.location.hash === "#teaserbox") this.changeRoute = true;

    return (
      <Router>
        { this.changeRoute ? this.routeChange() : null }
        { window.location.pathname === "/teaserbox" ?
        <TeaserBox resizeFns={this.resizeFns} />
        :
        <div className={"App" + (this.state.noUserSelections ? " no-selections" : "")}>
          <div className="App-wrapper">
            <div className="view">
              <ImageZoom state={this.state} updateState={this.updateState}></ImageZoom>
              {this.state.loading ?
                <div className="init-loader">Ladataan..</div> :
                <Navigation state={this.state} updateState={this.updateState}></Navigation>
              }
              <div className="main-col">
                {this.state.loading ?
                null :
                <Switch>
                  <Route exact path={this.state.phases[0].path}>
                    <Home state={this.state} updateState={this.updateState} />
                  </Route>
                  <Route path={this.state.phases[1].path} render={({history}) =>
                    !this.state.implementationModel ?
                      this.reRouteToHome(history) :
                      <Funding state={this.state} updateState={this.updateState} />
                  } />
                  <Route path={this.state.phases[2].path} render={({history}) =>
                    !this.state.implementationModel ||
                    !this.state.selectedFundings.length ?
                      this.reRouteToHome(history) :
                      <Comparison state={this.state} updateState={this.updateState} />
                  } />
                  <Route path={this.state.phases[3].path} render={({history}) =>
                    !this.state.implementationModel ||
                    !this.state.selectedFundings.length ?
                      this.reRouteToHome(history) :
                      <Contact state={this.state} updateState={this.updateState} />
                  } />
                  <Route path="/iframepoc">
                    <Iframepoc updateState={this.updateState} state={this.state} />
                  </Route>
                  <Route path="*">
                    <Redirect to="/" />
                  </Route>
                </Switch>}
              </div>
              <aside className="aside-col">
                <SidePanelContent state={this.state} updateState={this.updateState} resizeFns={this.resizeFns}></SidePanelContent>
              </aside>
            </div>
          </div>
          <ButtonArea state={this.state} updateState={this.updateState} />
        </div>
        }
      </Router>
    );
  }

}

export default App;
